// IMPORTS
import { addressFinder } from './addressFinder';
import { createProduct } from './adminReqs';
import {
  createReview,
  deleteReview,
  forgotPassword,
  login,
  logoutUser,
  resetPassword,
  showStatus,
  signUp,
  updateDetails,
} from './AxiosReqs';
import { addToCartTrigger, loadCart } from './cart';
import {
  addFeature,
  addSpec,
  Features,
  removeFeatures,
  Specs,
} from './featuresSpecs';
import { navSearch } from './NavSearch';
import { updateDelStatus, updateTrackingDetails } from './orderActions';
import { handlePayments } from './payments';
import { deleteProduct, updateProductFormOpen } from './prodAdminActions';
import { productSliderFn } from './productSlider';
import { renderCheckedFilters } from './renderCheckedFilters';

// * LOADING WRAPPER
if (window.location.pathname === '/' || window.location.pathname === '') {
  window.addEventListener('DOMContentLoaded', () => {
    document.getElementById('loading-overlay').style.display = 'flex';
    gsap.to('#loading-overlay', {
      scale: 1.5,
      opacity: 0,
      duration: 1,
      delay: 0.5,
      onComplete: () => {
        document.getElementById('loading-overlay').remove();
      },
    });
  });
} else {
  document.getElementById('loading-overlay').style.display = 'none';
}

// * SELECTORS
const mobileNav = document.querySelector('.mob-nav-menu');
const backNav = document.querySelector('.back-nav');
const location = document.querySelectorAll('.location');
const aboutImage = document.querySelector('.ab-img');
const topProdSlideMover = document.querySelector('.slide-mover');
const mobileFilterBtn = document.getElementById('mob-filter-opt');
const productSlider = document.querySelector('.product-slider');
const signUpPage = document.querySelector('.sign-cont');
const loginBtn = document.querySelector('#cta-login');
const forgotBtn = document.querySelector('#cta-forgot');
const resetBtn = document.querySelector('#cta-reset');
const reviewBtn = document.querySelector('.submit-review');
const updateDetailsBtn = document.querySelector('.update-btn');
const logoutBtn = document.querySelector('.logout');
const cartItems = document.querySelector('.cart-items');
const addToCartBtn = document.querySelector('#btn-atc');
const addressInput = document.querySelector('#address');
const checkoutBtn = document.querySelector('.checkout-btn');
const productForm = document.querySelector('#productForm');
const featureList = document.querySelector('#feature-list');
const specsList = document.querySelector('#specs-list');
const actions = document.querySelector('.admin-actions');
const prodActions = document.querySelector('.edit-btns');
const admOrders = document.querySelector('.orders-grid');
const updateTracking = document.querySelectorAll('#update-btn');
const searchCont = document.querySelectorAll('.search ');

// ! MOBILE NAVIGATION
if (mobileNav) {
  mobileNav.addEventListener('click', (e) => {
    const tl = gsap.timeline({ paused: true });
    tl.to('.mobile-nav', {
      x: '100%',
    });

    tl.play();

    backNav.addEventListener('click', (e) => {
      tl.reverse();
    });
  });
}

// ! LOCATION FINDER
if (location) {
  location.forEach((el) => {
    el.addEventListener('click', (e) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`;

          const res = await fetch(url);
          const data = await res.json();
          console.log(data.city);

          // * DISPLAY LOCATION
          const deliver = document.querySelectorAll('.loc-text h3');
          deliver.forEach((el) => (el.innerText = data.city));
        },
        (error) => console.log(error),
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    });
  });
}

// ! SLIDER
document.addEventListener('DOMContentLoaded', () => {
  const sliderWrapper = document.querySelector('.slider-wrapper');
  if (sliderWrapper) {
    const slides = document.querySelectorAll('.slide');
    const prevBtn = document.querySelector('.slider-btn.prev');
    const nextBtn = document.querySelector('.slider-btn.next');

    let currentIndex = 0;
    const totalSlides = slides.length;

    function updateSlider() {
      sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
    }

    // Auto-slide every 3 seconds
    let curInter;
    curInter = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlider();
    }, 3000);

    nextBtn.addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlider();
      clearInterval(curInter);

      // SETTING NEW INTERVAL
      curInter = setInterval(() => {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
      }, 3000);
    });

    prevBtn.addEventListener('click', () => {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateSlider();

      clearInterval(curInter);

      // SETTING NEW INTERVAL
      curInter = setInterval(() => {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
      }, 3000);
    });

    // * SWIPE DETECTION
    let startX = 0;
    let startY = 0;

    sliderWrapper.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });

    sliderWrapper.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;

      const diffX = endX - startX;
      const diffY = endY - startY;

      //  ONLY HORIZONTAL
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 20) {
        // RIGHT SWIPE
        if (diffX > 0) {
          currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
          updateSlider();

          clearInterval(curInter);

          // SETTING NEW INTERVAL
          curInter = setInterval(() => {
            currentIndex = (currentIndex + 1) % totalSlides;
            updateSlider();
          }, 3000);
        } else {
          currentIndex = (currentIndex + 1) % totalSlides;
          updateSlider();
          clearInterval(curInter);

          // SETTING NEW INTERVAL
          curInter = setInterval(() => {
            currentIndex = (currentIndex + 1) % totalSlides;
            updateSlider();
          }, 3000);
        }
      }
    });
  }
});

// ! ABOUT TRANSITION
if (aboutImage) {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          aboutImage.style.transform = 'translateX(0)';
          aboutImage.style.opacity = '1';
          aboutImage.style.transition =
            'transform 0.7s linear, opacity 0.7s linear';

          // * run only once
          obs.unobserve(aboutImage);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.15,
    }
  );

  aboutImage.style.transform = 'translateX(200px)';
  aboutImage.style.opacity = '0';
  observer.observe(aboutImage);
}

// GSAP -> IOS ISSUES
// if (aboutImage) {
//   gsap.registerPlugin(ScrollTrigger);
//   gsap.from('.ab-img', {
//     scrollTrigger: {
//       trigger: '.ab-img',
//       start: 'top 85%',
//     },
//     x: 200,
//     opacity: 0,
//     duration: 0.4,
//     ease: 'none',
//   });
// }

// ! TOP SLIDER
if (topProdSlideMover) {
  const topProds = document.querySelectorAll('.slide-comp');
  const prev = document.querySelector('.slider-btn-top.prev');
  const next = document.querySelector('.slider-btn-top.next');

  let currentIndex = 0;

  const slideWidth =
    topProds[0].offsetWidth +
    parseInt(getComputedStyle(topProds[0]).marginRight);

  const visibleSlides = Math.floor(
    topProdSlideMover.parentElement.offsetWidth / slideWidth
  );

  let maxTranslate =
    topProdSlideMover.scrollWidth - topProdSlideMover.parentElement.offsetWidth;

  window.innerWidth < 550 ? (maxTranslate += 35) : (maxTranslate += 25);

  function updateTransform(direction) {
    let translate;
    if (direction === 'next')
      translate =
        currentIndex * slideWidth + (window.innerWidth < 550 ? 35 : 25);
    else translate = translate = currentIndex * slideWidth;

    if (translate > maxTranslate) translate = maxTranslate; // clamp

    console.log(window.innerWidth);
    topProdSlideMover.style.transform = `translateX(-${translate}px)`;
  }

  next.addEventListener('click', () => {
    if (currentIndex < topProds.length - visibleSlides) {
      currentIndex++;
      updateTransform('next');
    }
  });

  prev.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateTransform('prev');
    }
  });
}

// ! MOBILE FILTERS
if (mobileFilterBtn) {
  mobileFilterBtn.addEventListener('click', (e) => {
    document.body.classList.add('no-scroll');
    const tl = gsap.timeline({ paused: true });
    tl.to('.mob-filters', {
      x: '100%',
    });

    tl.play();
    const closeBtn = document.querySelector('.f-close p');
    closeBtn.addEventListener('click', (e) => {
      tl.reverse();
      document.body.classList.remove('no-scroll');
    });
  });
}

// ! FILTER APPLY BTN -> QUERY CONSTRUCTOR
const filterCont = document.querySelector('.filters-cont');

if (filterCont) {
  renderCheckedFilters();
  let queryObj = {
    Category: [],
    Brand: [],
    TonerColor: [],
  };

  // Map keys in queryObj to actual query param names
  const keyMap = {
    Category: 'category',
    Brand: 'subCategory',
    TonerColor: 'color',
  };

  // Clear filters
  document.querySelector('.f-clear').addEventListener('click', () => {
    queryObj = { Category: [], Brand: [], TonerColor: [] };
    document
      .querySelectorAll('.filter-type input[type="checkbox"]')
      .forEach((cb) => (cb.checked = false));
  });

  // Handle checkbox change
  document.querySelectorAll('.filter-type ul li input').forEach((el) => {
    el.addEventListener('change', (e) => {
      let addInto = e.target
        .closest('.filter-type')
        .querySelector('h5').innerText;
      if (addInto === 'Toner Color') addInto = 'TonerColor';

      let toAdd = e.target.nextElementSibling.textContent.toLowerCase();
      if (toAdd === 'multifunction machines') toAdd = 'printers';

      if (e.target.checked) {
        if (!queryObj[addInto].includes(toAdd)) queryObj[addInto].push(toAdd);
      } else {
        queryObj[addInto] = queryObj[addInto].filter((v) => v !== toAdd);
      }
    });
  });

  // Apply filters
  document.querySelectorAll('.filter-apply').forEach((btn) => {
    btn.addEventListener('click', () => {
      const params = new URLSearchParams();

      Object.keys(queryObj).forEach((key) => {
        queryObj[key].forEach((val) => {
          params.append(keyMap[key], val);
        });
      });

      const queryStr = params.toString();
      console.log('Final Query:', queryStr);

      // API call
      window.location.search = queryStr;
    });
  });
}

// ! SORTING
const sortBtn = document.querySelector('.fil-sort select');
if (sortBtn) {
  sortBtn.addEventListener('change', (e) => {
    const params = new URLSearchParams(window.location.search);
    if (e.target.value === 'hightolow') params.set('sort', '-discountedPrice');
    else if (e.target.value === 'lowtohigh')
      params.set('sort', 'discountedPrice');
    else params.set('sort', '-createdAt');
    // console.log(params.toString());

    window.location.search = params.toString();
  });
}

// ! PRODUCT PAGE SLIDER
if (productSlider) {
  productSliderFn();
}

// ! SIGNUP
if (signUpPage) {
  const actionBtn = document.querySelector('#ctasign');
  actionBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    await signUp();
  });
}

// ! LOGIN
if (loginBtn) {
  loginBtn.addEventListener('click', (e) => {
    e.preventDefault();
    login();
  });
}

// ! FORGOT PASSWORD
if (forgotBtn) {
  forgotBtn.addEventListener('click', (e) => {
    e.preventDefault();
    forgotPassword();
  });
}

// ! RESET PASSWORD
if (resetBtn) {
  resetBtn.addEventListener('click', (e) => {
    e.preventDefault();
    resetPassword();
  });
}

// ! REVIEWS
if (reviewBtn) {
  reviewBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const productId = reviewBtn.dataset.product;
    createReview(productId);
  });
  const delReviewBtn = document.querySelectorAll('.del-review');
  if (delReviewBtn) {
    delReviewBtn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const prodId = e.target.dataset.product;
        const revId = e.target.dataset.review;
        deleteReview(prodId, revId);
      });
    });
  }
}

// ! UPDATE DETAILS
if (updateDetailsBtn) {
  updateDetailsBtn.addEventListener('click', (e) => {
    e.preventDefault();
    updateDetails();
  });
}

// ! LOGOUT
if (logoutBtn) {
  logoutBtn.addEventListener('click', (e) => {
    e.preventDefault();
    logoutUser();
  });
}

// ! RENDERING CART ON PAGE LOAD
if (cartItems) {
  loadCart(cartItems);
}

// ! ADDING TO CART
if (addToCartBtn) {
  addToCartBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addToCartTrigger(addToCartBtn);
  });
}

// ! FINDING CART ADDRESS
if (addressInput) {
  addressFinder(addressInput);
}

// ! HANDLING CART CHECKOUTS
if (checkoutBtn) {
  checkoutBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    const address = addressInput.value.trim();
    const products = JSON.parse(localStorage.getItem('dmcart'));
    if (!address || products.length === 0) {
      products.length === 0
        ? showStatus('fail', 'Cart is Empty')
        : showStatus('fail', 'Address is Missing');
      return;
    }
    await handlePayments(products, address);
  });
}

// ! PRODUCT FORM FEATURES
if (featureList) {
  addFeature(featureList);
}

if (specsList) {
  addSpec(specsList);
}

// ! PRODUCT FORM
if (productForm) {
  document
    .getElementById('productForm')
    .addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData();

      // * APPENDING INTO FORM BY NAME FIELD
      [
        'name',
        'description',
        'category',
        'subCategory',
        'originalPrice',
        'discountedPrice',
        'color',
      ].forEach((field) => {
        const valAppend =
          form[field].value === 'Select' ? '' : form[field].value;
        formData.append(field, valAppend);
      });

      // APPEDNING FEATURES AND SPECS
      Features.forEach((feature) => {
        formData.append('featuresList[]', feature);
      });

      // Specs → array of objects
      Specs.forEach((spec, i) => {
        formData.append(`specs[${i}][key]`, spec.key);
        formData.append(`specs[${i}][value]`, spec.value);
      });

      // Append Cover Image
      const coverImage = form.coverImage.files[0];
      if (!coverImage) return showStatus('fail', 'Cover Image Missing');
      formData.append('coverImage', coverImage);

      // Append Product Images
      const images = [
        form.image1.files[0],
        form.image2.files[0],
        form.image3.files[0],
      ].filter(Boolean);
      if (images.length === 0)
        return showStatus('fail', 'At least one product image is required');
      images.forEach((img) => formData.append('images', img));

      await createProduct(formData);
    });
}

// ! ACTIONS NAV
if (actions) {
  const cont = document.querySelector('.admin-actions');
  cont.addEventListener('click', (e) => {
    try {
      const id = e.target.closest('.action').id;
      if (id === 'add-prod') window.location = '/admin';
      else if (id === 'update-prod') window.location = '/admin/update-products';
    } catch (error) {}
  });
}

// ! PRODUCT ACTIONS
if (prodActions) {
  const editBtns = document.querySelectorAll('.edit-btns button');
  editBtns.forEach((btn) =>
    btn.addEventListener('click', (e) => {
      const id = e.target.closest('.edit-btns').dataset.id;
      const slug = e.target.closest('.edit-btns').dataset.slug;
      if (e.target.closest('button').id === 'delete') deleteProduct(id);
      else if (e.target.closest('button').id === 'edit')
        updateProductFormOpen(id, slug);
    })
  );
}

// ! ORDER ACTIONS
if (admOrders) {
  const deliveryBtns = document.querySelectorAll('.btn-success');
  deliveryBtns.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      const orderId = e.target.closest('.actions').dataset.orderid;
      await updateDelStatus(orderId);
    });
  });
}

if (updateTracking) {
  updateTracking.forEach((btn) =>
    btn.addEventListener('click', async (e) => {
      const orderId = e.target.closest('.actions').dataset.orderid;
      const trackingId = document.querySelector('#tracking-id').value;
      const trackingLink = document.querySelector('#tracking-link').value;

      await updateTrackingDetails(orderId, trackingId, trackingLink);
    })
  );
}

// ! SEARCH FUNCTIONALITY
if (searchCont) {
  searchCont.forEach((cont) => {
    const searchInput = cont.querySelector('input');
    searchInput.addEventListener('keyup', (e) => {
      e.preventDefault();
      if (e.key === 'Enter') navSearch(searchInput.value);
    });
  });
}
